module.exports = __webpack_public_path__ + "img/au.cab2eac6.svg";